import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client"
import { setContext } from "@apollo/client/link/context"
import { CustomWindow } from "../../custom"
import React from "react"
import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react"

declare let window: CustomWindow
export const enablePreview = window.env.REACT_APP_USE_TEST_RESOURCES
const apiToken = window.env.REACT_APP_CONTENTFUL_API_TOKEN

const httpLink = createHttpLink({
  uri: "https://graphql.contentful.com/content/v1/spaces/kzqg847wz5jr/",
})

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      "Content-Type": "application/json",
      Authorization: `Bearer ${apiToken}`,
    },
  }
})

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: enablePreview ? "no-cache" : undefined,
      variables: {
        preview: enablePreview,
      },
    },
  },
})

export const ContentfulLiveUpdates: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ContentfulLivePreviewProvider
    targetOrigin="https://app.contentful.com"
    locale="en-US"
    enableLiveUpdates={window.env.REACT_APP_USE_TEST_RESOURCES}
    enableInspectorMode={window.env.REACT_APP_USE_TEST_RESOURCES}
  >
    {children}
  </ContentfulLivePreviewProvider>
)
